import megaData from "@/data/nav-projects-mega.json";
import { t } from "@/lib/content";
import type { NavProjectsMegaCopy } from "@/lib/cc-nav-projects-mega";
import type { Lang } from "@/lib/types";

export function getNavProjectsMegaCopy(lang: Lang): NavProjectsMegaCopy {
  return {
    kicker: t(megaData.kicker, lang),
    seeAll: t(megaData.seeAll, lang),
  };
}

